import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';
import { marketingCampaignsQueryKey } from 'src/app/queries/marketing/get-campaigns';

import type { GridValidRowModel } from '@mui/x-data-grid-pro';
import type { UseQueryOptions } from '@tanstack/react-query';

const GET_CAMPAIGN_SMS_RECIPIENTS = 'api/marketing-campaign/get-sms-campaign-audience';

export type SmsRecipient = GridValidRowModel & {
  BouncedUtc: string | null;
  ClickedUtc: string | null;
  CustomerId: number;
  DeliveredUtc: string | null;
  FailedUtc: string | null;
  FirstName: string;
  LastName: string;
  PassedVerificationUtc: string | null;
  PhoneNumber: string;
  SentUtc: string | null;
  UnsubscribedUtc: string | null;
};

type CampaignSmsRecipientsResponse = {
  Data: SmsRecipient[];
  Page: number;
  TotalPages: number;
  TotalRows: number;
};

type CampaignSmsRecipientsQueryParams = {
  currentPage: number;
  endDate?: string;
  marketingCampaignId: string;
  pageSize: number;
  searchTerm?: string;
  sortAscending: boolean;
  sortColumn: string;
  startDate?: string;
};

export function useCampaignSmsRecipientsQuery(
  params: CampaignSmsRecipientsQueryParams,
  options: UseQueryOptions<CampaignSmsRecipientsResponse> = { enabled: true }
) {
  options.enabled = options.enabled && Boolean(params.marketingCampaignId && params.marketingCampaignId !== '0');

  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'sms-recipients', params],
    queryFn: async () =>
      fetchData<CampaignSmsRecipientsResponse>(
        GET_CAMPAIGN_SMS_RECIPIENTS,
        {
          MarketingCampaignId: parseInt(params.marketingCampaignId, 10),
          CurrentPage: params.currentPage,
          PageSize: params.pageSize,
          SearchTerm: params.searchTerm ?? '',
          SortAscending: params.sortAscending,
          SortColumn: params.sortColumn,
          StartDate: params.startDate,
          EndDate: params.endDate,
        },
        {
          error: { args: { message: 'Failed to fetch campaign SMS recipients.' } },
        }
      ),
    ...options,
  });
}
